import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useAdminNotifications(isAdmin: boolean) {
  const { data: pendingCount = 0 } = useQuery({
    queryKey: ["admin-notifications"],
    enabled: isAdmin,
    refetchInterval: 60000,
    queryFn: async () => {
      const [hands, contributors] = await Promise.all([
        supabase.from("hand_suggestions").select("id", { count: "exact", head: true }).eq("status", "pending"),
        supabase.from("suggested_contributors").select("id", { count: "exact", head: true }).eq("status", "pending"),
      ]);
      return (hands.count ?? 0) + (contributors.count ?? 0);
    },
  });

  return { pendingCount };
}
